var _rect, _g, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 124,
    viewBox: "0 0 358 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_863)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_169_863",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 358,
    height: 124
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 357,
    height: 123,
    rx: 15.5,
    fill: "#272733",
    stroke: "#EEEEEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_169_863)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: -21,
    width: 377,
    height: 165,
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 151.5,
    cy: 52.5,
    r: 117,
    stroke: "#21ACB9"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 161.5,
    cy: 52.5,
    r: 117,
    stroke: "#21ACB9"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 171.5,
    cy: 52.5,
    r: 117,
    stroke: "#21ACB9"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 181.5,
    cy: 52.5,
    r: 117,
    stroke: "#21ACB9"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 191.5,
    cy: 52.5,
    r: 117,
    stroke: "#21ACB9"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 201.5,
    cy: 52.5,
    r: 117,
    stroke: "#21ACB9"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.04,
    x1: 16,
    y1: 62.5,
    x2: 342,
    y2: 62.5,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceCard);
export default __webpack_public_path__ + "static/media/balance-card.c5c456f91bfe01d79282874e38c788d5.svg";
export { ForwardRef as ReactComponent };